<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="px-8 sm:px-8 lg:px-8 pt-6 pb-3">
            <div class="flex items-center justify-between gap-4">
                <h1 class="text-2xl font-semibold text-gray-900 truncate">
                    {{ pageTitle }}
                </h1>
                <router-link
                    class="btn-stage-primary"
                    :to="'/workspace/tickets/' + $route.params.id + '/manage'"
                >
                    Zum Ticket
                </router-link>
            </div>
        </div>

        <div class="stage-page-gutters stage-page-fill pt-1">
            <div class="w-full h-full bg-white shadow sm:rounded border border-gray-200 flex flex-col min-h-0">
                <div v-if="loading" class="p-4 text-gray-500">XML wird geladen...</div>

                <div v-else-if="error" class="p-4 text-red-600">{{ error }}</div>

                <div v-else class="p-4 flex-1 min-h-0">
                    <code-viewer
                        :code="xml"
                        :fill="true"
                        language="xml"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CodeViewer from "@/components/ui/code-viewer";

export default {
    name: "WorkspaceTicketXml",
    components: {
        CodeViewer,
    },
    data() {
        return {
            loading: true,
            error: '',
            xml: '',
            ticketSubject: '',
        };
    },
    computed: {
        pageTitle() {
            const subject = (this.ticketSubject || '').trim();
            return subject !== '' ? `Ticket ${subject} (XML)` : 'Ticket (XML)';
        },
    },
    methods: {
        loadXml() {
            const self = this;
            self.loading = true;
            self.error = '';

            axios.get('api/workspace/tickets/' + self.$route.params.id + '/xml', {
                responseType: 'text',
                headers: {
                    Accept: 'application/xml',
                },
            })
                .then(function (response) {
                    self.xml = response.data || '';
                    self.ticketSubject = self.extractSubjectFromXml(self.xml);
                })
                .catch(function (error) {
                    self.xml = '';
                    self.ticketSubject = '';
                    const message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Ticket XML konnte nicht geladen werden.';
                    self.error = message;
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        extractSubjectFromXml(xml) {
            if (!xml) {
                return '';
            }

            try {
                const parser = new window.DOMParser();
                const doc = parser.parseFromString(xml, 'application/xml');
                const node = doc.querySelector('ticket > subject');
                return node && node.textContent ? node.textContent.trim() : '';
            } catch (e) {
                return '';
            }
        },
    },
    mounted() {
        this.loadXml();
    },
    watch: {
        '$route.params.id': function () {
            this.loadXml();
        },
    },
    metaInfo() {
        return {
            title: this.pageTitle,
        };
    },
};
</script>
